var supportsPassive = function () {
  // simular to jQuery's test
  var supported = false;

  try {
    addEventListener('test', function () {// do nothing
    }, Object.defineProperty({}, 'passive', {
      get: function get() {
        supported = true;
        return true;
      }
    }));
  } catch (e) {// do nothing
  }

  return supported;
}();

export default supportsPassive;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd-touch-backend/dist/esm/utils/supportsPassive.js
// module id = 1139
// module chunks = 0